<section *ngIf="(isLoading$ | async) === false">
  <div class="create-service-container">
    <form
      [formGroup]="form"
      (ngSubmit)="applyRequest()"
      fxLayout="column"
      fxLayoutAlign="center"
      *ngIf="createInfo$ | async; else noDataTemplate"
    >
      <div>
        <div
          class="create-service-container__service-category"
          [ngClass]="{ 'error-border': hasTopicErrors() }"
          *ngFor="let item of (createInfo$ | async)?.topics; let i = index"
        >
          <div class="create-service-container__service-category-title">
            {{ item.description }}
          </div>

          <div class="flex-col">
            <ng-container *ngIf="!item?.topicAreas?.length">
              <ng-container
                *ngTemplateOutlet="scenariosContentTemplate"
              ></ng-container>
            </ng-container>

            <aran-tabs
              *ngIf="item?.topicAreas?.length"
              [tabs]=" [
              {
                label: 'Scenarios',
                template: scenariosContentTemplate,
              },
              {
                label: 'Airports',
                template: airportsContentTemplate,
              },
              {
                label: 'FIRs',
                template: firsContentTemplate,
              },
            ]"
              [selectedIndex]="selectedIndexes[i]"
              (tabChanged)="onTabChanged($event, i)"
              [design]="'underline'"
              [fitInkBarToContent]="true"
              [stretchTabs]="false"
              [alignTabs]="'start'"
              [dynamicHeight]="false"
              [animationDuration]="'300ms'"
              [ignoreContentAnimation]="true"
            >
            </aran-tabs>

            <ng-template #scenariosContentTemplate>
              <div class="flex flex-col mt-4">
                <div
                  *ngIf="item.subTopicSelectionOptions.length > 0"
                  class="flex justify-between items-center pb-4"
                >
                  <mat-radio-group
                    name="subTopicRadioGroup_{{ i }}"
                    (change)="
                      onSubTopicSelectionChange(
                        $event.value,
                        i,
                        getScenarioKey(i)
                      )
                    "
                    [value]="
                      form.get('topics')?.value[i]?.subTopicSelectedOption
                    "
                  >
                    <mat-radio-button
                      *ngFor="let option of item.subTopicSelectionOptions"
                      [value]="option.value"
                      class="mr-4 block"
                      color="primary"
                    >
                      {{ option.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div
                  class="flex flex-col"
                  *ngIf="
                    (item.subTopicSelectionOptions.length > 0 &&
                      getSubTopicSelectedOption(i) === 2) ||
                    item.subTopicSelectionOptions.length === 0
                  "
                >
                  <div
                    class="checkboxHeader-container flex justify-end items-center pb-2 pt-2"
                    *ngIf="item.subTopics.length > 1"
                  >
                    <div class="detailTableSearchContainer">
                      <aran-input
                        type="text"
                        label="Search"
                        fxFlex="100%"
                        [outline]="true"
                        [isClearable]="true"
                        [(ngModel)]="filters[getScenarioKey(i)]"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="applyFilter(getScenarioKey(i))"
                        (handleReset)="resetFilter(getScenarioKey(i))"
                      ></aran-input>
                    </div>
                  </div>

                  <ng-container
                    *ngIf="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length;
                      else noInfoFoundTemplate
                    "
                  >
                    <div class="mt-4 flex flex-col">
                      <mat-checkbox
                        *ngFor="
                          let service of item.subTopics
                            | filterByText
                              : filters[getScenarioKey(i)]
                              : 'description'
                            | paginate : pagingConfig[getScenarioKey(i)]
                        "
                        color="primary"
                        (change)="
                          onSubTopicCheckboxChange($event, i, service.id)
                        "
                        [checked]="getSubTopicIds(i).includes(service.id!)"
                      >
                        {{ service.description }}
                      </mat-checkbox>
                    </div>
                  </ng-container>

                  <aran-pagination
                    *ngIf="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length > itemsPerPage
                    "
                    [uniqueKey]="getScenarioKey(i)"
                    [totalItems]="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length
                    "
                    [currentPage]="pagingConfig[getScenarioKey(i)].currentPage"
                    [itemsPerPage]="
                      pagingConfig[getScenarioKey(i)].itemsPerPage
                    "
                    [pageSizeOptions]="pageSizeOptions"
                    [maxSize]="maxSize"
                    [footerTablePagination]="
                      pagingConfig[getScenarioKey(i)].footerTablePagination
                    "
                    (handlePaginate)="
                      onHandlePaginate($event, getScenarioKey(i))
                    "
                    (handleChangePageSize)="
                      onHandlePageSize($event, getScenarioKey(i))
                    "
                  ></aran-pagination>
                </div>
              </div>
            </ng-template>

            <ng-template #airportsContentTemplate>
              <div class="flex items-center p-2 airports_info-container">
                <mat-icon class="mr-1 shrink-0">info</mat-icon>
                <span>{{ airportsInfoText }}</span>
              </div>
              <div class="flex flex-col mt-4">
                <div
                  class="flex justify-between items-center pb-4"
                  *ngIf="item.topicAreaSelectionOptions.length > 0"
                >
                  <mat-radio-group
                    name="subAreaAeodromeHeliportRadioGroup_{{ i }}"
                    (change)="
                      onTopicAreaSelectionChange(
                        $event.value,
                        i,
                        item.topicAreas
                      )
                    "
                    [value]="
                      form.get('topics')?.value[i]?.topicAreaSelectedOption
                    "
                  >
                    <mat-radio-button
                      *ngFor="let option of item.topicAreaSelectionOptions"
                      [value]="option.value"
                      class="mr-4 block"
                      color="primary"
                    >
                      {{ option.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div
                  class="flex flex-col"
                  *ngIf="
                    (item.topicAreaSelectionOptions.length > 0 &&
                      getTopicAreasSelectedOption(i) === 4) ||
                    item.subTopicSelectionOptions.length === 0
                  "
                >
                  <div
                    class="checkboxHeader-container flex justify-end items-center pb-2 pt-2"
                    *ngIf="
                      (item.topicAreas | areaType : ['Aerodrome', 'Heliport'])
                        .length > 1
                    "
                  >
                    <div class="detailTableSearchContainer">
                      <aran-input
                        type="text"
                        label="Search"
                        fxFlex="100%"
                        [outline]="true"
                        [isClearable]="true"
                        [(ngModel)]="filters[getAirportKey(i)]"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="applyFilter(getAirportKey(i))"
                        (handleReset)="resetFilter(getAirportKey(i))"
                      ></aran-input>
                    </div>
                  </div>

                  <ng-container
                    *ngIf="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length;
                      else noInfoFoundTemplate
                    "
                  >
                    <div class="mt-4 flex flex-col">
                      <mat-checkbox
                        *ngFor="
                          let item of item?.topicAreas
                            | areaType : ['Aerodrome', 'Heliport']
                            | filterByText : filters[getAirportKey(i)] : 'code'
                            | paginate : pagingConfig[getAirportKey(i)]
                        "
                        color="primary"
                        (change)="onAreaCheckboxChange($event, i, item.id)"
                        [checked]="isAreaChecked(i).includes(item.id!)"
                      >
                        {{ item.code }}
                      </mat-checkbox>
                    </div>
                  </ng-container>

                  <aran-pagination
                    *ngIf="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length > itemsPerPage
                    "
                    [uniqueKey]="getAirportKey(i)"
                    [totalItems]="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length
                    "
                    [currentPage]="pagingConfig[getAirportKey(i)].currentPage"
                    [itemsPerPage]="pagingConfig[getAirportKey(i)].itemsPerPage"
                    [pageSizeOptions]="pageSizeOptions"
                    [maxSize]="maxSize"
                    [footerTablePagination]="
                      pagingConfig[getAirportKey(i)].footerTablePagination
                    "
                    (handlePaginate)="
                      onHandlePaginate($event, getAirportKey(i))
                    "
                    (handleChangePageSize)="
                      onHandlePageSize($event, getAirportKey(i))
                    "
                  ></aran-pagination>
                </div>
              </div>
            </ng-template>

            <ng-template #firsContentTemplate>
              <div class="flex items-center p-2 airports_info-container">
                <mat-icon class="mr-1 shrink-0">info</mat-icon>
                <span>{{ airportsInfoText }}</span>
              </div>
              <div class="flex flex-col">
                <div
                  class="checkboxHeader-container cancel-top-border flex justify-end items-center pb-2 pt-2"
                  *ngIf="(item.topicAreas | areaType : 'Airspace').length > 1"
                >
                  <div class="detailTableSearchContainer">
                    <aran-input
                      type="text"
                      label="Search"
                      fxFlex="100%"
                      [outline]="true"
                      [isClearable]="true"
                      [(ngModel)]="filters[getFirKey(i)]"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="applyFilter(getFirKey(i))"
                      (handleReset)="resetFilter(getFirKey(i))"
                    ></aran-input>
                  </div>
                </div>
                <ng-container
                  *ngIf="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length;
                    else noInfoFoundTemplate
                  "
                >
                  <div class="mt-4 flex flex-col">
                    <mat-checkbox
                      *ngFor="
                        let item of item?.topicAreas
                          | areaType : 'Airspace'
                          | filterByText : filters[getFirKey(i)] : 'code'
                          | paginate : pagingConfig[getFirKey(i)]
                      "
                      color="primary"
                      (change)="onAreaCheckboxChange($event, i, item.id)"
                      [checked]="isAreaChecked(i).includes(item.id!)"
                    >
                      {{ item.code }}
                    </mat-checkbox>
                  </div>
                </ng-container>

                <aran-pagination
                  *ngIf="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length > itemsPerPage
                  "
                  [uniqueKey]="getFirKey(i)"
                  [totalItems]="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length
                  "
                  [currentPage]="pagingConfig[getFirKey(i)].currentPage"
                  [itemsPerPage]="pagingConfig[getFirKey(i)].itemsPerPage"
                  [pageSizeOptions]="pageSizeOptions"
                  [maxSize]="maxSize"
                  [footerTablePagination]="
                    pagingConfig[getFirKey(i)].footerTablePagination
                  "
                  (handlePaginate)="onHandlePaginate($event, getFirKey(i))"
                  (handleChangePageSize)="
                    onHandlePageSize($event, getFirKey(i))
                  "
                ></aran-pagination>
              </div>
            </ng-template>
          </div>
        </div>
        <div style="margin-top: -12px">
          <mat-error
            class="topicsMatError"
            *ngIf="shouldShowTopicsError('subTopic2MustHaveIds')"
          >
            At least one sub-topic must be entered for the sub-topic selected as
            'Custom'.
          </mat-error>

          <mat-error
            class="topicsMatError"
            *ngIf="shouldShowTopicsError('topicAreaSelectionInvalid')"
          >
            A topic area suitable for the selected fields must be chosen.
          </mat-error>

          <mat-error
            class="topicsMatError"
            *ngIf="shouldShowTopicsError('subTopicRequiredForTopicArea')"
          >
            A sub-topic must be selected for the chosen topic area.
          </mat-error>

          <mat-error
            class="topicsMatError"
            *ngIf="shouldShowTopicsError('atLeastOneSubTopicRequired')"
          >
            At least one sub-topic must be selected.
          </mat-error>
        </div>
      </div>

      <div class="mt-5">
        <aran-button
          [type]="'submit'"
          [name]="'Apply'"
          [disabled]="!form.valid"
          [className]="!form.valid ? 'btn_disabled' : ''"
        ></aran-button>
      </div>
    </form>

    <ng-template #noDataTemplate>
      <ng-container *ngIf="!(isLoading$ | async)">
        <aran-no-data text="No information found"></aran-no-data>
      </ng-container>
    </ng-template>

    <ng-template #noInfoFoundTemplate>
      <ng-container *ngIf="!(isLoading$ | async)">
        <div class="noInfoFound py-4 px-4">No matching results found.</div>
      </ng-container>
    </ng-template>
  </div>
</section>
